import { render } from "./SliderControls.vue?vue&type=template&id=33b5f6e4&scoped=true"
import script from "./SliderControls.vue?vue&type=script&lang=js"
export * from "./SliderControls.vue?vue&type=script&lang=js"

import "./SliderControls.vue?vue&type=style&index=0&id=33b5f6e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b5f6e4"]])

export default __exports__